import { UserTransactionReasonDto } from './dtos/transactions'

export const enum UserTransactionReason {
  Unknown = 'Unknown',
  BackgroundCheck = 'BackgroundCheck',
  Penalty = 'Penalty',
  Bonus = 'Bonus',
  MiscPayment = 'MiscPayment',
  MiscAbatement = 'MiscAbatement',
}

export function parseUserTransactionReason(
  dto: UserTransactionReasonDto,
): UserTransactionReason {
  switch (dto) {
    case 'BACKGROUND_CHECK':
      return UserTransactionReason.BackgroundCheck
    case 'PENALTY':
      return UserTransactionReason.Penalty
    case 'BONUS':
      return UserTransactionReason.Bonus
    case 'MISC_PAYMENT':
      return UserTransactionReason.MiscPayment
    case 'MISC_ABATEMENT':
      return UserTransactionReason.MiscAbatement
  }
  console.warn('Unknown user transaction reason', dto)
  return UserTransactionReason.Unknown
}

export function serializeUserTransactionReason(
  reason: UserTransactionReason,
): UserTransactionReasonDto {
  switch (reason) {
    case UserTransactionReason.BackgroundCheck:
      return 'BACKGROUND_CHECK'
    case UserTransactionReason.Penalty:
      return 'PENALTY'
    case UserTransactionReason.Bonus:
      return 'BONUS'
    case UserTransactionReason.MiscPayment:
      return 'MISC_PAYMENT'
    case UserTransactionReason.MiscAbatement:
      return 'MISC_ABATEMENT'
  }

  throw new Error(`Cannot serialize unknown transaction reason '${reason}'`)
}
